import { useState, useEffect } from "react";
import axios from "axios";

// Fetches store config once and caches it in module scope
let cachedConfig = null;
let fetchPromise = null;

const fetchConfig = () => {
  if (!fetchPromise) {
    fetchPromise = axios
      .get("/api/config")
      .then((res) => {
        cachedConfig = res.data;
        return cachedConfig;
      })
      .catch(() => {
        fetchPromise = null; // allow retry on error
        return { shippingCost: 150, freeShippingThreshold: 1500 };
      });
  }
  return fetchPromise;
};

export const useStoreConfig = () => {
  const [config, setConfig] = useState(
    cachedConfig || { shippingCost: 150, freeShippingThreshold: 1500 }
  );

  useEffect(() => {
    if (!cachedConfig) {
      fetchConfig().then(setConfig);
    }
  }, []);

  return config;
};
